const ArrowRight = (props) => (
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M14.43 19.3201C14.24 19.3201 14.05 19.2501 13.9 19.1001C13.61 18.8101 13.61 18.3301 13.9 18.0401L19.44 12.5001L13.9 6.96012C13.61 6.67012 13.61 6.19012 13.9 5.90012C14.19 5.61012 14.67 5.61012 14.96 5.90012L21.03 11.9701C21.32 12.2601 21.32 12.7401 21.03 13.0301L14.96 19.1001C14.81 19.2501 14.62 19.3201 14.43 19.3201Z"
            fill="white"
        />
        <path
            d="M20.33 13.25H3.5C3.09 13.25 2.75 12.91 2.75 12.5C2.75 12.09 3.09 11.75 3.5 11.75H20.33C20.74 11.75 21.08 12.09 21.08 12.5C21.08 12.91 20.74 13.25 20.33 13.25Z"
            fill="white"
        />
    </svg>
);

export default ArrowRight;
